module.exports = __webpack_public_path__ + "static/media/4.64e7d16d.jpg";